module.exports = __webpack_public_path__ + "img/chat-details8.4f8f20d9.png";